import { httpCompanyDetailQueryGateway } from '../../_shared/infrastructure/company-detail-query.http';
import type { InstitutionalDetailGateway } from './institutional-detail.gateway';

/** Client Institutional Detail → the shared company-detail endpoints (licence-scoped server-side). */
export const httpInstitutionalDetailGateway: InstitutionalDetailGateway =
  httpCompanyDetailQueryGateway;
